export const paymentStatus: { [key: string]: string } = {
    paid: "Paid",
    Unpaid: "Unpaid",
}